import React, { useState, useEffect, useRef, useContext } from 'react';
import { Routes, Route, Navigate, useLocation, useNavigate } from 'react-router-dom';
import Header from '../Header/Header';
import Footer from '../Footer/Footer';
import Admin from '../Admin/Admin';
import Loading from '../Loading/Loading';
import PowerBiReport from '../PowerBiReport/PowerBiReport';
import BreadcrumbBar from '../BreadcrumbBar/BreadcrumbBar';
import NotesHistory from '../NotesHistory/NotesHistory';
import CalendarDetails from '../CalendarDetails/CalendarDetails';
import FacilityUserMonitoredIndividualView from '../FacilityUserMonitoredIndividualView/FacilityUserMonitoredIndividualView';
import FacilityUserUnitView from '../FacilityUserUnitView/FacilityUserUnitView';
import CardContainer from '../CardContainer/CardContainer';
import Messages from '../Messages/Messages';
import DeviceDetails from '../DeviceDetails/DeviceDetails';
import InactivityLogout from '../InactivityLogout/InactivityLogout';
import MonitoredIndividualSummary from '../MonitoredIndividualSummary/MonitoredIndividualSummary';
//import decoder from 'jwt-decode';
import authentication from '../../B2CAuth';

import './Secured.css';
import convenienceApi from '../../common/api/convenience';
import { CheckinProvider } from '../../contexts/CheckinContext';
import { EnvironmentContext } from '../../contexts/EnvironmentContext';
import { AdminContext } from '../../contexts/AdminContext';
import { userCanVisitRoute } from '../../common/adminPermissions';
import baseApi from '../../common/api/base';
import logComponent from '../../common/logComponent';
import SurveyResponses from '../SurveyResponses/SurveyResponses';

export default function Secured() {
  const environmentContext = useContext(EnvironmentContext);
  const adminContext = useContext(AdminContext);
  const location = useLocation();
  const navigate = useNavigate();

  const [tokenExpiration, setTokenExpiration] = useState(null);
  const [dataError, setDataError] = useState(false);
  const [dataLoadFailures, setDataLoadFailures] = useState(0);
  const [tokenUpdateTimeout, setTokenUpdateTimeout] = useState(null);
  const { activeUser: user, organization, userModules, selectedMonitoredIndividual, clearSelectedMonitoredIndividual, clearSelectedUnit, shouldUpdateModules, shouldUpdateCheckInSurvey, selectedImpersonationUser, selectedImpersonationUserEmail, reloadingFromJSON, hasToken } = environmentContext;

  const dataLoadingRef = useRef(false);
  const tokenExpirationRef = useRef(null);
  const tokenUpdateTimeoutRef = useRef(null);
  const hasTokenRef = useRef(false);
  const organizationRef = useRef(false);
  const getInitialTokenIntervalRef = useRef(null);
  const getUpdatedTokenIntervalRef = useRef(null);


  if (logComponent('Secured')) { console.debug('Secured rendered'); }




  const canViewAdmin = user && (user.isAdmin || user.groupTypeString === 'Status Solutions');
  const canViewIndividuals = userModules && userModules.some(module => module.name === 'Individual/Unit Search');

  //const { instance } = useMsal();
  //const [accessToken, setAccessToken] = useState(null);
  //const [idToken, setIdToken] = useState(null);

  const dataErrorRef = useRef(false);
  const dataLoadFailuresRef = useRef(0);

  const setDataErrorRef = (el) => {
    if (logComponent('Secured')) { console.debug('Secured setDataErrorRef'); }
    dataErrorRef.current = el;
    setDataError(el);
  }

  const setDataLoadFailuresRef = (el) => {
    if (logComponent('Secured')) { console.debug('Secured setDataLoadFailuresRef'); }
    dataLoadFailuresRef.current = el;
    setDataLoadFailures(el);
  }


  const setDataLoadingRef = (el) => {
    if (logComponent('Secured')) { console.debug('Secured setDataLoadingRef'); }
    dataLoadingRef.current = el;
  }

  const setTokenExpirationRef = (el) => {
    if (logComponent('Secured')) { console.debug('Secured setTokenExpirationRef'); }
    tokenExpirationRef.current = el;
    setTokenExpiration(el);
  }

  const setTokenUpdateTimeoutRef = (el) => {
    if (logComponent('Secured')) { console.debug('Secured setTokenUpdateTimeoutRef'); }
    tokenUpdateTimeoutRef.current = el;
    setTokenUpdateTimeout(el);
  }

  const setHasTokenRef = (el) => {
    if (logComponent('Secured')) { console.debug('Secured setHasTokenRef'); }
    hasTokenRef.current = el;
    environmentContext.setHasToken(el);
  }

  const setOrganizationRef = (el) => {
    if (logComponent('Secured')) { console.debug('Secured setOrganizationRef'); }
    organizationRef.current = el;
  }

  const setGetInitialTokenIntervalRef = (el) => {
    if (logComponent('Secured')) { console.debug('Secured setGetInitialTokenInterval'); }
    getInitialTokenIntervalRef.current = el;
  }

  const setGetUpdatedTokenIntervalRef = (el) => {
    if (logComponent('Secured')) { console.debug('Secured setGetUpdatedTokenInterval'); }
    getUpdatedTokenIntervalRef.current = el;
  }  

  useEffect(() => {
    if (logComponent('Secured')) { console.debug('Secured onMount'); }
    const previousEnvironmentContext = JSON.parse(sessionStorage.getItem('previousEnvironmentContext'));
    if (user == null &&
      previousEnvironmentContext &&
      previousEnvironmentContext.user != null) {

      environmentContext.reloadFromJSON();

    }
    authentication.updateToken();

    //loginAndAcquireToken();
    setGetInitialTokenIntervalRef(setInterval(getInitialToken, 500))
  }, [])


  useEffect(() => {
    if (logComponent('Secured')) {
     console.debug('Secured useEffect location hash = ' + location.hash + ' and pathname = ' + location.pathname);
    }
    if (!user || reloadingFromJSON || !hasTokenRef.current ) return;

    if (user.groupTypeString === 'Facility') {
      if (!location.pathname.startsWith('/monitoredindividual')) clearSelectedMonitoredIndividual();
      if (!location.pathname.startsWith('/unit')) clearSelectedUnit();
    }
  }, [location.pathname]);

  useEffect(() => {
    if (logComponent('Secured')) {console.debug('Secured useEffect [shouldUpdateModules]'); }
    if (!user || reloadingFromJSON || !hasTokenRef.current) return;
    if (shouldUpdateModules) {
      reloadModules();
    }
  }, [shouldUpdateModules]);

  useEffect(() => {
    if (logComponent('Secured')) { console.debug('Secured useEffect [shouldUpdateCheckInSurvey]'); }
    if (!user || reloadingFromJSON || !hasTokenRef.current) return;
    if (shouldUpdateCheckInSurvey) {
      reloadCheckInSurvey();
    }
  }, [shouldUpdateCheckInSurvey]);

  useEffect(() => {
    if (logComponent('Secured')) {console.debug('Secured useEffect [environmentContext.selectedImpersonationUser]'); }
    
    if (!user || reloadingFromJSON || !hasTokenRef.current ) return;

    if (!selectedImpersonationUser) {
      loadData(false);

    } 


  }, [environmentContext.selectedImpersonationUser])

  useEffect(() => {
    if (logComponent('Secured')) { console.debug('Secured useEffect [environmentContext.selectedImpersonationUserEmail]'); }

    if (!user || reloadingFromJSON || !hasTokenRef.current ) return;

    if (selectedImpersonationUserEmail) {
      loadData(true);
    }


  }, [environmentContext.selectedImpersonationUserEmail])



  //  const loginAndAcquireToken = (successCallback) => {
  //    const { instance } = useMsal();
  //    const [accessToken, setAccessToken] = useState(null);
  //    const [idToken, setIdToken] = useState(null);
  //    let user = getCurrentUser();

  //    if (!user) {
  //        // user is not logged in
  //        if (state.noScopes) {
  //            // no need of access token, just redirect to login page
  //            instance.loginRedirect(appConfig.scopes);
  //        } else {
  //            // try to get token from SSO session
  //            instance.acquireTokenSilent(appConfig.scopes, null, null, "&login_hint&domain_hint=organizations")
  //                .then(response => {
  //                    setAccessToken(response.accessToken);
  //                    setIdToken(repsonse.idToken);
  //                    if (successCallback) {
  //                        successCallback();
  //                    }
  //                }, error => {
  //                    if (error) {
  //                        // This handles error "AADB2C90077: User does not have an existing session and request prompt parameter has a value of 'None'."
  //                        // (AKA user interaction is required) by redirecting the user to login
  //                        instance.loginRedirect(appConfig.scopes);
  //                    }
  //                });
  //        }
  //    } else {
  //        // the user is already logged in
  //        //TODO:  Do we need this line
  //        //state.idToken = user.idToken;

  //        const userIsSigningInAfterPasswordReset = instance.authority &&
  //            idToken.tfp &&
  //            !instance.authority.toLowerCase().includes(idToken.tfp.toLowerCase()) &&
  //            instance.authority.includes(appConfig.signInPolicy.toLowerCase());

  //        if (userIsSigningInAfterPasswordReset) {
  //            const storedAccessToken = sessionStorage.getItem(idToken);
  //            state.accessToken = storedAccessToken;
  //            sessionStorage.removeItem(idToken);

  //            const newinstance = appConfig.instance ? appConfig.instance : 'https://login.microsoftonline.com/tfp/';
  //            const newauthority = `${newinstance}${appConfig.tenant}/${appConfig.signInPolicy}`;

  //            baseApi.User.UnsetUpdateForcePasswordChangeNextSignIn()
  //                .then(res => {
  //                    state.firstLoginRedirect = false;
  //                    const isLogout = !state.firstLoginRedirect;
  //                    // This logout is a workaround for https://statusqatest.atlassian.net/browse/MIMI-91
  //                    instance.logoutRedirect({
  //                        postLogoutRedirectUri: "/",
  //                    });
  //                    instance.authority = authority;
  //                    state.firstLogin = false;
  //                    state.firstLoginRedirect = false;
  //                    instance.loginRedirect(appConfig.scopes);
  //                }, err => {
  //                    instance.authority = authority;
  //                    instance.loginRedirect(appConfig.scopes);
  //                });
  //        } else {
  //            if (state.noScopes) {
  //                if (successCallback) {
  //                    successCallback();
  //                }
  //            } else {
  //                // get access token
  //                instance.acquireTokenSilent(appConfig.scopes).then(response => {

  //                    setAccessToken(response.accessToken);
  //                    setIdToken(response.idToken);
  //                    state.accessToken = accessToken;
  //                    if (!state.firstLoginRedirect) {
  //                        const decoded = decoder(response.accessToken);
  //                        for (let prop in decoded) {
  //                            if (prop.match('ForcePasswordChangeNextSignIn')) {
  //                                state.firstLogin = decoded[prop];
  //                            }
  //                        }
  //                    }

  //                    if (state.firstLogin && !state.firstLoginRedirect) {
  //                        if (typeof (Storage) !== "undefined") {
  //                            sessionStorage.setItem(response.idToken, response.accessToken);
  //                        }
  //                        state.firstLoginRedirect = true;
  //                        redirectToPasswordReset();
  //                    } else {
  //                        state.firstLoginRedirect = false;
  //                        if (successCallback) {
  //                            successCallback();
  //                        }
  //                    }
  //                },
  //                    error => {
  //                        if (error) {
  //                            instance.acquireTokenRedirect(appConfig.scopes);
  //                        }
  //                    });
  //            }
  //        }
  //    }
  //}



  //  const getTokenExpirationTime = (accessToken) => {
  //    if(!accessToken) return null;
  //    const decoded = decoder(accessToken);

  //    const utcSeconds = decoded.exp;
  //    const d = new Date(0); // 0 is the key, which sets the date to the epoch
  //    d.setUTCSeconds(utcSeconds);

  //    return d;
  //  }
  //  const getCurrentUser = (accessToken) => {
  //    const decoded = decoder(accessToken);
  //    let decodedForcePasswordChangeNextSignIn = false;
  //    for (let prop in decoded) {
  //      if (prop.match('ForcePasswordChangeNextSignIn')) {
  //          decodedForcePasswordChangeNextSignIn = decoded[prop];
  //      }
  //    }

  //    return {
  //        name: decoded.name,
  //        firstName: decoded.given_name,
  //        lastName: decoded.family_name,
  //        emails: decoded.emails,
  //        forcePasswordChangeNextSignIn: decodedForcePasswordChangeNextSignIn
  //    }
  //  }


  const getInitialToken = () => {
    if (logComponent('Secured')) { console.debug('Secured getInitialToken'); }

    //    const [accessToken] = useState(null);
    const previousEnvironmentContext = JSON.parse(sessionStorage.getItem('previousEnvironmentContext'));
    const token = authentication.getAccessToken();

    //    if (accessToken) {
    if (token) {

      setHasTokenRef(true);
    } else {
      setHasTokenRef(false);
    }
    let expiration = authentication.getTokenExpirationTime();

    let exprationPrimitive = expiration ? expiration.valueOf() : null;
    //let expiration = getTokenExpirationTime(accessToken);

    if (exprationPrimitive && exprationPrimitive !== tokenExpirationRef.current) {
    //if (tokenExpirationRef.current == null || (exprationPrimitive && exprationPrimitive !== tokenExpirationRef.current)) {
      clearInterval(getInitialTokenIntervalRef.current);
      const updateTime = exprationPrimitive - 240000; // 4 minutes prior to expiration
      const updateDelay = updateTime - Date.now();

      setTokenExpirationRef(exprationPrimitive);
      setGetInitialTokenIntervalRef(null);
      setTokenUpdateTimeoutRef(setTimeout(updateToken, updateDelay));

      var tokenUser = authentication.getCurrentUser();
      var emailAddress = tokenUser.emails[0];
      var userEmailIsSameAsToken = (user != null && emailAddress !== user.emailAddress);
      var cachedInLastFifteenSeconds = previousEnvironmentContext && previousEnvironmentContext.unloadTime && typeof previousEnvironmentContext.unloadTime === 'number' && Date.now() < previousEnvironmentContext.unloadTime + 15000;
      var refreshing = !user && (previousEnvironmentContext && previousEnvironmentContext.user) && cachedInLastFifteenSeconds;
      if (!userEmailIsSameAsToken && !refreshing && token) {
        loadData(false);
      }


    }
  }

  const updateToken = () => {
    if (logComponent('Secured')) {console.debug('Secured updateToken'); }
    authentication.updateToken();
    //loginAndAcquireToken();

    getUpdatedToken();
    setGetUpdatedTokenIntervalRef(
      setInterval(getUpdatedToken, 1000)
    );
  }

  const getUpdatedToken = () => {
    if (logComponent('Secured')) {console.debug('Secured useEffect [location.pathname]'); }
      
    const token = authentication.getAccessToken();

    if (token) {
      //TODO:  Fix getting the auth token
      //const [accessToken] = useState(null);

      //  if (accessToken) {
      setHasTokenRef(true);
    } else {
      setHasTokenRef(false);
    }

    let expiration = authentication.getTokenExpirationTime();
    //let expiration = getTokenExpirationTime(accessToken);

    if (expiration && expiration.valueOf() !== tokenExpiration) {
      clearInterval(getUpdatedTokenIntervalRef.current);
      const updateTime = expiration.valueOf() - 300000; // 5 minutes prior to expiration
      const updateDelay = updateTime - Date.now();

      setTokenExpiration(expiration.valueOf());
      setGetInitialTokenIntervalRef(null);
      setTokenUpdateTimeout(setTimeout(updateToken, updateDelay));

    }
  }

  const loadData = (forImpersonateUser) => {
    if (logComponent('Secured')) {
      console.debug('Secured loadData: hasTokenRef.current: ' + (hasTokenRef.current ? 'true' : 'false') + ': forImpersonation: ' + (forImpersonateUser ? 'true' : 'false') );
    }
    const previousEnvironmentContext = JSON.parse(sessionStorage.getItem('previousEnvironmentContext'));
    //const token = authentication.getAccessToken();
    //let continue = !hasTokenRef.current;
    if (!hasTokenRef.current || dataLoadingRef.current === true) return;

    setDataLoadingRef(true);
    //if (!token) return;
    if (!user && previousEnvironmentContext && previousEnvironmentContext.user) return;


    convenienceApi.getSecuredData(forImpersonateUser)
      .then(
        data => {
          let groupTypeString = data.user.groupTypeString;

          if (forImpersonateUser) {
            data.selectedImpersonationUser = data.user;
            delete data.user;
          }
          environmentContext.update(data);

          if (groupTypeString === 'Facility') {
            setOrganizationRef(data.organization);
            loadMonitoredIndividualsAndUnits();
          }
          setDataLoadingRef(false);

        },
        error => {
          
          // Attempt to load data again, but only 3 times
          if (logComponent('Secured')) { console.error(error); }
          setDataErrorRef(true);
          setDataLoadFailuresRef(dataLoadFailuresRef.current + 1);

          setDataLoadingRef(false);


          if (dataLoadFailuresRef.current < 3) {
            loadData(forImpersonateUser);
          } else {
            setTimeout(() => {
              navigate('/logout');
            }, 2000);
          }


        }
    );
  }

  const loadMonitoredIndividualsAndUnits = () => {
    if (logComponent('Secured')) {console.debug('Secured loadMonitoredIndividualsAndUnits');}

    if (!organizationRef.current || !hasTokenRef.current) return;

    convenienceApi.getFacilityMonitoredIndividualsAndUnits(organizationRef.current)
      .then(
        data => {
          adminContext.setMonitoredIndividuals(data.monitoredIndividuals);
          adminContext.setUnits(data.units);
        },
        error => {
          // TODO: Retry
        }
      )
  }

  const reloadModules = () => {
    if (logComponent('Secured')) { console.debug('Secured reloadModules');
  }
    if (!hasTokenRef.current) return;

    const selectedMonitoredIndividualId = selectedMonitoredIndividual ? selectedMonitoredIndividual.monitoredIndividualId : null;

    baseApi.Module.GetAllForCurrentUser(selectedMonitoredIndividualId)
      .then(result => {
        environmentContext.setUserModules(result.data);
      });
  }

  const reloadCheckInSurvey = () => {
    if (logComponent('Secured')) {
      console.debug('Secured reloadCheckInSurvey');
    }
    if (!hasTokenRef.current) return;


    baseApi.Survey.GetCheckInSurveyForCurrentUser()
      .then(result => {
        environmentContext.setCheckinSurvey(result.data);
      });
  }


  return (
    <div className="Secured">
        {
            user ?
            <React.Fragment>
              <Header />
              <BreadcrumbBar />
              <main
                className="Secured__main-content">
                <Routes>
                  {
                    tokenExpiration ?
                      <Route path="/" element={<CardContainer />} />
                      : <Route path="/" element={<Loading />} />

                  }
                  {
                    userCanVisitRoute(user, '/reports') ?
                      <Route path="/reports/:reportId" element={<PowerBiReport />} />
                      :null

                  }
                  {
                    userCanVisitRoute(user, '/devices') ?
                    <Route path="/devices/*" element={<DeviceDetails />} />
                      : null
                  }
                  {
                    userCanVisitRoute(user, '/monitoredindividual') && canViewIndividuals ? 
                      <Route path='/monitoredindividual/:monitoredIndividualId/*' element={<FacilityUserMonitoredIndividualView />} />
                      : null
                  }
                  {
                    userCanVisitRoute(user, '/unit') && canViewIndividuals ?
                    <Route path="/unit/:unitId/*" element={<FacilityUserUnitView />} />
                      :null
                  }
                  {
                    userCanVisitRoute(user, '/notes') ?
                    <Route path="/notes/*" element={<NotesHistory />} />
                      :null
                  }
                  {
                    (user.groupTypeString === 'Family' ||
                      (user.groupTypeString === 'Facility' && user.hasCorrespondenceViaGroupsOrOverride)) ?
                    <Route path="/messages/*" element={<Messages />} />
                      :null
                  }
                  {
                    (user.groupTypeString === 'Facility' && user.hasViewSurveyResponsesViaGroupsOrOverride) ?
                      <Route path="/responses/*" element={<SurveyResponses />} />
                      : null
                  }
                  {
                    userCanVisitRoute(user, '/calendar') ?
                    <Route path="/calendar/*" element={<CalendarDetails />} />
                      :null
                  }
                  {
                    canViewAdmin ?
                    <Route path="/admin/*" element={<Admin />} />
                      :null
                  }
                </Routes>
              </main>
              <Footer />
              <InactivityLogout maxInactivity={3600} warningPeriod={120} />
            </React.Fragment> :
            dataLoadFailures < 3 ?
              <Loading message={dataError ? 'We\'re having some trouble loading the application.  Please wait...' : null} /> :
              <p className="Secured__data-failure-message">Something went wrong!  Redirecting to the landing page...</p>
              
        }
    </div>
  );
}